import { render, staticRenderFns } from "./CashupHistoryDayshifts.vue?vue&type=template&id=345a5954"
import script from "./CashupHistoryDayshifts.vue?vue&type=script&lang=js"
export * from "./CashupHistoryDayshifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports